module.exports = __webpack_public_path__ + "img/faro.d83d18cd.gif";